module.exports = __webpack_public_path__ + "img/progress_065.2c6f1e70.png";